var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondGrayLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.707107,
    y: 8,
    width: 10.3137,
    height: 10.3137,
    rx: 0.5,
    transform: "rotate(-45 0.707107 8)",
    fill: "#63666E",
    stroke: "#63666E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondGrayLarge);
export default __webpack_public_path__ + "static/media/diamondGrayLarge.d8a7f3d27f42679b975e1431584e12eb.svg";
export { ForwardRef as ReactComponent };